import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription, catchError, exhaustMap, firstValueFrom, interval, map, of, switchMap, takeUntil } from 'rxjs';
import { CloudTypes, Entities, FileTypes } from 'src/app/core/models/globals';
import { Node } from 'src/app/core/models/node';
import { ShowOutput } from 'src/app/core/models/showOutput';
import { FileTabContent } from 'src/app/core/models/storage';
import { AwsCloudService } from 'src/app/core/services/aws-cloud.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { GoogleCloudService } from 'src/app/core/services/google-cloud.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { JobsService } from 'src/app/core/services/jobs.service';
import { NodeService } from 'src/app/core/services/node.service';
import { StorageDataTransferService } from 'src/app/core/services/storage-data-transfer.service';
import { StorageOracleService } from 'src/app/core/services/storage-oracle.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { JobConfirmationDialogComponent } from 'src/app/modules/job/modals/jobActions/job-confirmation-dialog/job-confirmation-dialog.component';

@Component({
	selector: 'app-view-file',
	templateUrl: './view-file.component.html',
	styleUrl: './view-file.component.scss'
})
export class ViewFileComponent implements AfterViewChecked {

	@Input() depName: string;
	@Input() jobName: string;
	@Input() path: string;
	@Input() vmNodeName: string;
	@Input() id: string;
	@Input() depId: string;
	@Input() state: string;
	@Input() entityType: Entities;
	@Input() currentStorageName: string;

	constructor(
		// public dialogRef: MatDialogRef<JobOutputDialogComponent>,
		public jobService: JobsService,
		public dialog: MatDialog,
		private _headerService: HeaderService,
		private storageService: StorageService,
		private awsService: AwsCloudService,
		private spinner: NgxSpinnerService,
		private myElement: ElementRef, private depService: DeploymentService,
		private syncConfig: SyncConfigService, private _oracleService: StorageOracleService,
		private _googleService: GoogleCloudService, private env: EnvironmentService,
		private _azureService: StorageDataTransferService,
		private snackBar: MatSnackBar,
		private sanitizer: DomSanitizer,
		private deploymentService: DeploymentService,
		private nodeService: NodeService,
		private _http: HttpClient
	) { }

	response: ShowOutput;
	jobFileName: string;
	jobOutputData: string;
	regexCode: string = 'gi';
	isSensitiveTitle: string = 'case-insensitive';
	jobOutput: string = ' ';
	searchTerm: string;
	totalWordCount: number = 0;
	curvalue: number = 0;
	currentWordIndex: number = 0;
	totalElements: number;
	findExppr;
	trimmedFileName;
	startIdx;
	isSensitive: boolean = false;
	autoScroll: boolean = false;
	contentEditable: boolean = false;
	toShowPipe: boolean = false;
	disabled: boolean = true;
	toShow: boolean = false;
	dataCheckSubs: Subscription;
	loadDataSub: Subscription;
	toggleDialog: boolean = false;
	trimIndex: number = 420;
	dataEmpty: boolean = false;
	manualDisable: boolean = false;
	isDarkMode: boolean = true;
	isAutoRefreshEnabled: boolean = false;

	cloudType: any = CloudTypes.OnPremise;

	totalFileLines = -1;
	linePerPage = this.env.envVariables.storageViewFileLinesPerPage;
	toShowPaginator: boolean = false;
	@ViewChild('outputFileName') outputFileName;
	@ViewChild("editedFile") EditedFile;
	sanitizedImageUrl: SafeUrl;
	sanitizedVideoUrl: SafeUrl;
	sanitizedModelViewerUrl: SafeUrl;
	sanitizedAudioUrl: SafeUrl;

	@ViewChild('zoomContainer') zoomContainer!: ElementRef;

	zoomScale: number = 1;
	minZoom: number = 0.5;
	maxZoom: number = 3;
	offsetX: number = 0;
	offsetY: number = 0;

	isDragging = false;
	startX = 0;
	startY = 0;
	startOffsetX = 0;
	startOffsetY = 0;

	currentPage: number = -1;
	totalPages: number;
	lastScrollHeight: number;

	private destroy$ = new Subject<void>();
	private loadOutput$ = new Subject<void>();
	private PaginationLoadOutput$ = new Subject<void>();
	FileTypes = FileTypes;
	showInvalidMessage: boolean = false;
	routeViaSynchpc: boolean;
	VMName: string = null;
	headNodeIp: string = null;

	ngOnInit() {
		try {
			this.routeViaSynchpc = this.deploymentService.getProfileInfoFromSubject(this.depName)?.routeViaSynchpc || false;
			this.cloudType = this._headerService.getCloudNameForDeployment(this.depName);
			this.toShowPaginator = this.cloudType == CloudTypes.OnPremise && !this.depId && !this.jobName;
			this.spinner.show(this.path);
			this.handleFileNameTrim();
			// this.loadOutput$.next();
			this.loadOutput$.pipe(exhaustMap(() => this.loadOutputData()), takeUntil(this.destroy$)).subscribe();
			this.PaginationLoadOutput$.pipe(switchMap(() => this.loadOutputData()), takeUntil(this.destroy$)).subscribe();
			this.loadOutput$.next();

		} catch (e) {
		}
	}

	ngOnDestroy() {
		if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
		this.destroy$.next();
		this.destroy$.complete();
	}

	@ViewChild('scrollMe') private myScrollContainer: ElementRef;
	ngAfterViewChecked() {
		if (this.autoScroll) {
			this.scrollToBottom();
			this.autoScroll = false;
		}
	}

	handleFileNameTrim() {
		if (this.path.length > 75) {
			if (this.path.length > 110) {
				this.startIdx = this.path.length - 75
			} else {
				this.startIdx = 25
			}
			this.trimmedFileName = '...' + this.path.substring(this.startIdx, this.path.length)
		} else {
			this.trimmedFileName = this.path;
		}
		this.jobFileName = this.path;
	}

	handleFileCacheData() {
		const cacheData = this.storageService.getContentForFile(this.path, this.depName, this.entityType, this.currentPage);
		const totalLines = this.storageService.getTotalLinesForFile(this.path, this.depName, this.entityType);
		if (totalLines > 0) {
			this.totalFileLines = totalLines;
		}
		if (cacheData) {
			if (!this.totalPages) this.totalPages = Math.ceil(this.totalFileLines / this.linePerPage);
			if (!this.currentPage || this.currentPage == -1) this.currentPage = this.totalPages;
			this.manageOutputData(cacheData.data);
			this.autoScroll = true;
		}
	}

	loadOutputData() {
		if (!this.isAutoRefreshEnabled) this.handleFileCacheData();

		const fileData$ = () => {
			if (this.path.includes(this.env.envVariables.workStoreRoute) || this.cloudType == CloudTypes.OnPremise) {
				if (FileTypes.checkIfImage(this.path) || FileTypes.checkIfVideo(this.path) || FileTypes.checkIfModelViewer(this.path)) {
					this.showInvalidMessage = false;
					let path = this.path.replace("/mnt/", "");
					if (
						this.path.includes(this.env.envVariables.workStoreRoute) &&
						this.deploymentService.isLocalStoreEnabled(this.depName)
					) {
						let tempWorkStoreRoute =
							this.env.envVariables.workStoreRoute.replace("/mnt/", "");
						if (this.toShow) {
							// toShow indicates if user is in Jobs module or Storage Module
							path = path.replace(
								tempWorkStoreRoute,
								`${'All'}/${tempWorkStoreRoute}`
							);
							if ((this.VMName || this.VMName != "") && !path.includes(this.VMName)) {
								path = path.replace(
									tempWorkStoreRoute,
									`${this.VMName}/${tempWorkStoreRoute}`
								);
								path = path.replace("All/", "");
							}
						} else {
							if (this.VMName || this.VMName != "") {
								path = path.replace(
									tempWorkStoreRoute,
									`${this.VMName}/${tempWorkStoreRoute}`
								);
								// if(vmName || vmName != ""){
								// 	path = path.replace(tempWorkStoreRoute, `${vmName}/${tempWorkStoreRoute}`);
								// }
							}
						}
					}

					return this.nodeService.getNodesForDeployment(this.depName).pipe(
						switchMap((data: any) => {
							let nodes = <Node[]>JSON.parse(JSON.stringify(data));
							if (nodes) {
								let idx = nodes.findIndex((n) => n.nodeType.includes("Head"));
								if (idx >= 0) {
									let selectedVmName = nodes[idx].vmName;
									this.VMName = selectedVmName;
									return this.storageService.getVmIP(this.depName, selectedVmName).pipe(
										map((ipData: any) => {
											this.headNodeIp = JSON.parse(JSON.stringify(ipData.vmIp));


											// This creates a URL for given file
											let url = this.deploymentService.getUrlForUtilityService(
												this.depName,
												this.headNodeIp,
												this.env.envVariables.BMFileDownloadPORT,
												2,
												this.routeViaSynchpc,
												path
											);

											return url;
										})
									);
								}
							}
							return of(null);
						}),
						catchError(err => {
							console.error(err);
							this.spinner.hide(this.path);
							this.showInvalidMessage
							return of(null);
						})
					);

				}

				let pageData = {
					totalLines: this.isAutoRefreshEnabled ? -1 : this.totalFileLines,
					pageSize: this.linePerPage,
					currentIndex: this.isAutoRefreshEnabled ? -1 : (this.currentPage != -1 ? this.currentPage - 1 : -1),
				}
				return this.storageService.viewFileData(this.depName, this.path, this.vmNodeName, pageData);
			} else {
				if (this.cloudType == CloudTypes.MicrosoftAzure && !this.path.includes(this.env.envVariables.workStoreRoute)) {
					const isBlob = true;
					if (isBlob) {
						this._azureService.viewBlob(this.path).subscribe({
							next: (data) => {
								this.manageOutputData(data);
							}, error: (err) => {
								this.spinner.hide(this.path);
								this.jobOutput = 'Some error occurred... Please try again!';
								this.jobFileName = this.path;
							}
						});
					} else {
						const fileName = this.path.split('/').pop();
						const filePath = this.path.split('/').slice(0, -1).join('/');
						return this._azureService.getFileContent(filePath, fileName);
					}
				} else if (this.cloudType == CloudTypes.Oracle && !this.path.includes(this.env.envVariables.workStoreRoute)) {
					if(FileTypes.checkIfText(this.path, this.env.envVariables.TextFileExtension)){
						return this._oracleService.viewFileData(this._headerService.getStorageNameForDeployment(this.depName), this.path);
					}
					else{
						return of(this._oracleService.downloadFile(this._headerService.getStorageNameForDeployment(this.depName), this.path));
					}
				} else if (this.cloudType == CloudTypes.Google && !this.path.includes(this.env.envVariables.workStoreRoute)) {
					if(FileTypes.checkIfText(this.path, this.env.envVariables.TextFileExtension)){
						return this._googleService.viewFileData(this.depName, this._headerService.getStorageNameForDeployment(this.depName), this.path);
					}
					else{
						return this._googleService.downloadFile(this.depName, this._headerService.getStorageNameForDeployment(this.depName), this.path);
					}
				} else if (this.cloudType == CloudTypes.AWS && !this.path.includes(this.env.envVariables.workStoreRoute)) {
					if(FileTypes.checkIfText(this.path, this.env.envVariables.TextFileExtension)){
						return this.awsService.viewFileData(this.depName, this.currentStorageName, this.path);
					}
					else{
						return this.awsService.downloadFile(this.depName, this.currentStorageName, this.path);
					}
				} else {
					let pageData = {
						totalLines: this.isAutoRefreshEnabled ? -1 : this.totalFileLines,
						pageSize: this.linePerPage,
						currentIndex: this.isAutoRefreshEnabled ? -1 : (this.currentPage != -1 ? this.currentPage - 1 : -1),
					}
					return this.storageService.viewFileData(this.depName, this.path, this.vmNodeName, pageData);
				}
			}
		};

		// Use exhaustMap to manage multiple calls
		return fileData$()?.pipe(
			exhaustMap((data: any) => {
				if (typeof data == 'string') {
					data = { FileData: data, FileLines: 0 };
				}
				this.totalFileLines = data.FileLines;
				 if (!this.totalPages || this.isAutoRefreshEnabled) {
          this.totalPages = Math.ceil(this.totalFileLines / this.linePerPage);
        }
        if (!this.currentPage || this.currentPage == -1 || this.isAutoRefreshEnabled) {
          this.currentPage = this.totalPages;
        }
		
				if (this.totalPages == 0) this.totalPages = 1;
				if (!this.currentPage || this.currentPage == -1) this.currentPage = this.totalPages;
				if (!data.FileData) {
					data.FileData = "Either file is empty or node is inactive.";
					this.totalFileLines = -1;
					this.totalPages = null;
					this.currentPage = -1;
				}
				this.manageOutputData(data?.FileData || data);
				return of(null);
			}),
			catchError(err => {
				this.spinner.hide(this.path);
				this.jobOutput = 'Some error occurred... Please try again!';
				this.jobFileName = this.path;
				return of(null);  // handle the error and complete the observable
			}),
			takeUntil(this.destroy$)
		)
	}

	private scrollToBottom(): void {
		try {
			if (this.lastScrollHeight == undefined) {
				this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
				this.lastScrollHeight = this.myScrollContainer.nativeElement.scrollTop;
			} else {
				if (this.lastScrollHeight <= this.myScrollContainer.nativeElement.scrollTop) {
					this.lastScrollHeight = this.myScrollContainer.nativeElement.scrollTop;
					this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
				}
			}
		} catch (err) { }
	}

	loadOutputData2() {
		if (!this.isAutoRefreshEnabled) this.handleFileCacheData();
		if (this.cloudType == CloudTypes.Oracle && !this.path.includes(this.env.envVariables.workStoreRoute)) {
			this._oracleService.viewFileData(this._headerService.getStorageNameForDeployment(this.depName), this.path).subscribe({
				next: (data) => {
					this.manageOutputData(data);
				}, error: (err) => {
					this.spinner.hide(this.path);
					this.jobOutput = 'Some error occurred... Please try again!';
					this.jobFileName = this.path;
				}
			})
		}
		else if (this.cloudType == CloudTypes.Google && !this.path.includes(this.env.envVariables.workStoreRoute)) {
			this._googleService.viewFileData(this.depName, this._headerService.getStorageNameForDeployment(this.depName), this.path).subscribe({
				next: (data) => {
					this.manageOutputData(data);
				}, error: (err) => {
					this.spinner.hide(this.path);
					this.jobOutput = 'Some error occurred... Please try again!';
					this.jobFileName = this.path;
				}
			})
		}
		else if (this.cloudType == CloudTypes.AWS && !this.path.includes(this.env.envVariables.workStoreRoute)) {
			this.awsService.viewFileData(this.depName, this.currentStorageName, this.path).subscribe({
				next: (data) => {
					this.manageOutputData(data);
				}, error: (err) => {
					this.spinner.hide(this.path);
					this.jobOutput = 'Some error occurred... Please try again!';
					this.jobFileName = this.path;
				}
			})
		}
		else {
			let pageData = {
				totalLines: this.totalFileLines,
				pageSize: this.linePerPage,
				currentIndex: this.currentPage != -1 ? this.currentPage - 1 : -1,
			}
			this.loadDataSub = this.storageService.viewFileData(this.depName, this.path, this.vmNodeName, pageData).subscribe({
				next: (op: any) => {
					this.totalFileLines = op.FileLines;
					if (!op.FileData) {
						op.FileData = "Either file is empty or node is inactive.";
					}
					if (!this.totalPages) this.totalPages = Math.floor(this.totalFileLines / this.linePerPage) + 1;
					if (!this.currentPage || this.currentPage == -1) this.currentPage = this.totalPages;
					this.manageOutputData(op.FileData);
				},
				error: error => {
					this.spinner.hide(this.path);
					this.jobOutput = "Some error occurred... Please try again!";
					this.jobFileName = this.path;
				},
			});
		}
	}

	async manageOutputData(op) {
		this.showInvalidMessage = false;
		if (this.path.length > 75) {
			if (this.path.length > 110) {
				this.startIdx = this.path.length - 75
			} else {
				this.startIdx = 25
			}
			this.trimmedFileName = '...' + this.path.substring(this.startIdx, this.path.length)
		} else {
			this.trimmedFileName = this.path;
		}
		this.jobFileName = this.path;

		if (FileTypes.checkIfImage(this.path)) {
			try {
				if (
					this.cloudType == CloudTypes.OnPremise || 
					this.path.includes(this.env.envVariables.workStoreRoute)					
				) {
					const encodedUrl = this.encodeUrlSafely(op);
					this.sanitizedImageUrl = this.sanitizer.bypassSecurityTrustUrl(encodedUrl);
				} 
				else if(
					this.cloudType == CloudTypes.Google ||
					this.cloudType == CloudTypes.AWS || 
					this.cloudType == CloudTypes.Oracle
				){
					this.sanitizedImageUrl = this.sanitizer.bypassSecurityTrustUrl(op);
				}
				else {
					const objectUrl = URL.createObjectURL(op);
    				this.sanitizedImageUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
				}
				this.isDarkMode = false;
			} catch (err) {
				console.error('Image preview failed:', err);
			}
		}
		else if (FileTypes.checkIfVideo(this.path)) {
			try {
				if( this.cloudType == CloudTypes.OnPremise ||
					this.path.includes(this.env.envVariables.workStoreRoute) ||
					this.cloudType == CloudTypes.MicrosoftAzure
				){

					const encodedUrl = this.encodeUrlSafely(op);
					this.sanitizedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(encodedUrl);
				}
				else{
					this.sanitizedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(op);
				}
			} catch (err) {
				console.error('Video preview failed:', err);
			}
			this.spinner.hide(this.path);
			this.isDarkMode = false;
			this.showInvalidMessage = true;
			return;
		}
		else if (FileTypes.checkIfModelViewer(this.path)) {

			if (this.cloudType == CloudTypes.OnPremise) {
				const blob = await firstValueFrom(this._http.get(op, { responseType: 'blob' }));
				const objectUrl = URL.createObjectURL(blob);
				this.sanitizedModelViewerUrl = objectUrl;

			} else {
				this.sanitizedModelViewerUrl = op;
			}
			this.spinner.hide(this.path);
			this.isDarkMode = false;
			return;
		}
		else if (FileTypes.checkIfText(this.path, this.env.envVariables.TextFileExtension)) {
			this.jobOutput = op.toString();
			if (op != "Either file is empty or node is inactive." && op != null) {
				const cacheData: FileTabContent = { page: this.currentPage, data: op };
				this.storageService.updateContentForFile(this.path, this.depName, this.entityType, cacheData, this.totalFileLines);
			} else {
				this.storageService.removeViewFileCacheData(this.path, this.depName);
			}
      this.searchKeyword(this.searchTerm);
		}
		else if (FileTypes.checkIfAudio(this.path)) {  // this is not fully implemented yet
			try {
				if (op instanceof Blob) {
					const blobUrl = URL.createObjectURL(op);
					this.sanitizedAudioUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
				} else if (typeof op === 'string') {
					this.sanitizedAudioUrl = this.sanitizer.bypassSecurityTrustResourceUrl(op);
				} else {
					throw new Error('Unsupported audio format type');
				}
			} catch (err) {
				console.error('Audio preview failed:', err);
			}
			return;
		}
		else {
			this.snackBar.open('File type not supported', 'Close', { duration: 3000, });
		}

		this.toShowPipe = true;
		if (this.autoScroll == false) this.autoScroll = true;
		this.spinner.hide(this.path);
		this.showInvalidMessage = true;
	}

	manualRefresh() {
		this.manualDisable = true;
		setTimeout(() => {
			this.manualDisable = false;
		}, 7000);
		this.handlePageEvent(this.totalPages);
	}

	autoRefresh() {
    this.disabled = false;
		this.isAutoRefreshEnabled = true;
		this.handlePageEvent(this.totalPages);
		this.dataCheckSubs = interval(this.syncConfig.config.jobs.outputReqInterval).pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.loadOutput$.next();
		});
	}

	pause() {
		this.disabled = true;
		this.autoScroll = false;
		this.isAutoRefreshEnabled = false;
		this.dataCheckSubs.unsubscribe();
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
	}

	onCancel() {
		if (this.contentEditable == true) {
			this.dialog.open(JobConfirmationDialogComponent, {
				width: '30%',
				height: '25%',
				autoFocus: true,
				disableClose: true,
				data: {
					actionValue: 51,
					title: 'Save File ',
					message: 'All changes will be lost, do you want to continue?',
					noBtnText: 'No',
					yesBtnText: 'Yes',
				},
			})
				.afterClosed()
				.subscribe(res => {
					if (res.data == 'Yes') {
						this.spinner.hide(this.path);
						if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
						if (this.loadDataSub) this.loadDataSub.unsubscribe();
						// this.dialogRef.close()
					}
				});
		} else {
			this.spinner.hide(this.path);
			if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
			if (this.loadDataSub) this.loadDataSub.unsubscribe();
			// this.dialogRef.close();
		}
	}

	onEdit() {
		this.contentEditable = true;
		this.autoScroll = false;
		if (this.loadDataSub) this.loadDataSub.unsubscribe();
	}

	onSave() {
		this.dialog.open(JobConfirmationDialogComponent, {
			width: '30%',
			height: '25%',
			autoFocus: true,
			disableClose: true,
			data: {
				actionValue: 51,
				title: 'Save File ',
				message: 'Do you want to save the changes ?',
				noBtnText: 'No',
				yesBtnText: 'Yes',
			},
		})
			.afterClosed()
			.subscribe(res => {
				if (res.data) {
					this.contentEditable = false;
					let newJobOutput = this.EditedFile.nativeElement.innerHTML;
					this.jobOutput = newJobOutput;
				}
			});
	}

	searchKeyword(value: string) {
		this.searchTerm = value
		if (this.searchTerm == undefined || this.searchTerm.length == 1 && this.searchTerm == '.') {
		} else {
			if (this.searchTerm == '' || this.searchTerm == undefined) {
				this.clearSearch()
			} else {
				this.findExppr = new RegExp(value, this.regexCode)
				this.totalWordCount = (this.jobOutput.match(this.findExppr) || []).length
				this.autoScroll = false;
			}
			if (this.totalWordCount != 0 && this.currentWordIndex == 0) {
				this.currentWordIndex = 1;
			}
			if (this.totalWordCount == 0) {
				this.currentWordIndex = 0;
			}
		}
	}

	makeCaseSensitive() {
		this.isSensitive = !this.isSensitive;
		this.autoScroll = false;
		if (this.isSensitive == true) {
			this.regexCode = 'g'
			this.isSensitiveTitle = 'case-sensitive'
		} else {
			this.regexCode = 'gi'
			this.isSensitiveTitle = 'case-insensitive'
		}
		this.jobOutput = this.jobOutput + ''
		this.searchKeyword(this.searchTerm)
	}

	clearSearch() {
		const dom: HTMLElement = this.myElement.nativeElement;
		dom.querySelectorAll('.marked').forEach(mark => {
			mark.setAttribute("style", "background-color: ''")
		})
		this.searchTerm = '';
		this.totalWordCount = 0;
		this.curvalue = 0;
		this.currentWordIndex = 0
		this.regexCode = 'gi'
		this.isSensitive = false;
		this.autoScroll = false;
	}

	removeAttrStyle(dom) {
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #fcf8e3")
	}

	findNext() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrStyle(dom)
		this.curvalue = this.curvalue + 1;
		this.currentWordIndex = this.currentWordIndex + 1
		if (this.curvalue == this.totalWordCount) {
			this.curvalue = 0
			this.currentWordIndex = this.curvalue + 1
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0;");
		dom.querySelectorAll(".marked")[this.curvalue].scrollIntoView({
			behavior: 'auto',
			block: 'center',
			inline: 'center'
		});
	}

	findPrevious() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrStyle(dom)
		this.curvalue = this.curvalue - 1;
		this.currentWordIndex = this.currentWordIndex - 1
		if (this.currentWordIndex == 0) {
			this.curvalue = this.totalWordCount - 1
			this.currentWordIndex = this.totalWordCount;
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0");
		dom.querySelectorAll(".marked")[this.curvalue].scrollIntoView({
			behavior: 'auto',
			block: 'center',
			inline: 'center'
		});
	}

	handlePageEvent(e: any) {
		if (this.totalPages == 0) return;
		// check if e is a number using regex. it should be greater than 1 and less than totalPages
		if (this.totalPages != null && !/^\d+$/.test(e) || e < 1 || e > this.totalPages) {
			this.snackBar.open('Invalid page number', 'Close', {
				duration: 3000,
			});
			return;
		}
		this.spinner.show(this.path);
		this.currentPage = e != null ? e : this.currentPage;
		this.PaginationLoadOutput$.next();
	}

	onMouseWheel(event: WheelEvent): void {
		event.preventDefault();
		const zoomStep = 0.1;
		const prevZoom = this.zoomScale;

		const rect = this.zoomContainer.nativeElement.getBoundingClientRect();
		const cursorX = event.clientX - rect.left;
		const cursorY = event.clientY - rect.top;

		const relX = (cursorX - rect.width / 2 - this.offsetX) / this.zoomScale;
		const relY = (cursorY - rect.height / 2 - this.offsetY) / this.zoomScale;

		if (event.deltaY < 0 && this.zoomScale < this.maxZoom) {
			this.zoomScale = Math.min(this.zoomScale + zoomStep, this.maxZoom);
		} else if (event.deltaY > 0 && this.zoomScale > this.minZoom) {
			this.zoomScale = Math.max(this.zoomScale - zoomStep, this.minZoom);
		}

		const scaleChange = this.zoomScale / prevZoom;
		this.offsetX -= relX * (scaleChange - 1);
		this.offsetY -= relY * (scaleChange - 1);
	}

	startDrag(event: MouseEvent): void {
		this.isDragging = true;
		this.startX = event.clientX;
		this.startY = event.clientY;
		this.startOffsetX = this.offsetX;
		this.startOffsetY = this.offsetY;
	}

	stopDrag(): void {
		this.isDragging = false;
	}

	onDrag(event: MouseEvent): void {
		if (!this.isDragging) return;

		const dx = event.clientX - this.startX;
		const dy = event.clientY - this.startY;
		let nextOffsetX = this.startOffsetX + dx;
		let nextOffsetY = this.startOffsetY + dy;

		const container = this.zoomContainer.nativeElement;
		const containerWidth = container.offsetWidth;
		const containerHeight = container.offsetHeight;

		const img: HTMLImageElement = container.querySelector('img');
		const imgWidth = img.naturalWidth;
		const imgHeight = img.naturalHeight;

		const scaledWidth = imgWidth * this.zoomScale;
		const scaledHeight = imgHeight * this.zoomScale;

		const maxOffsetX = Math.max((scaledWidth - containerWidth) / 2, 0);
		const maxOffsetY = Math.max((scaledHeight - containerHeight) / 2, 0);

		this.offsetX = Math.max(-maxOffsetX, Math.min(nextOffsetX, maxOffsetX));
		this.offsetY = Math.max(-maxOffsetY, Math.min(nextOffsetY, maxOffsetY));
	}

	resetZoom(): void {
		this.zoomScale = 1;
		this.offsetX = 0;
		this.offsetY = 0;
	}

	encodeUrlSafely(url) {
		try {
			if (!url || typeof url !== 'string') return url;

			const urlParts = url.split('/');
			const filename = urlParts.pop();

			const encodedFilename = encodeURIComponent(filename);

			urlParts.push(encodedFilename);
			return urlParts.join('/');
		} catch (error) {
			console.error('URL encoding failed:', error);
			return url;
		}
	}

}
